import type { I18nPrefix } from '@sparklayer-io/dashboard/i18n/prefix';

// The sidebar renders in the host but its copy ships with the dash-only bundle, so it is
// translated alongside the rest of the app chrome.
export const I18N_SIDEBAR = 'features:app.components.sidebar' satisfies I18nPrefix;
export const I18N_USER_MENU = 'features:app.components.user_menu' satisfies I18nPrefix;
export const I18N_SITE_SWITCHER = 'features:app.components.site_switcher' satisfies I18nPrefix;
